import { COST_RANGES } from '../components/constants';

export function getCostRange(cost) {
  if (cost == null || cost === 0) return COST_RANGES[0]; // "free"
  if (cost <= 30) return COST_RANGES[1];  // "$"
  if (cost <= 80) return COST_RANGES[2];  // "$$"
  if (cost <= 150) return COST_RANGES[3]; // "$$$"
  return COST_RANGES[4];                  // "$$$$"
}
